// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mRm8","rootNoMargin":"styles_rootNoMargin__3Sst_"};